import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  isSuccess: false,
  success: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.DELETE_COMPANY_LOGO_REQUEST:
      return {
        isfetching: true,
        isSuccess: false,
        success: '',
        error: '',
      };
    case actionConstants.DELETE_COMPANY_LOGO_SUCCESS:
      return {
        isfetching: false,
        isSuccess: true,
        success: action.message,
        error: '',
      };
    case actionConstants.DELETE_COMPANY_LOGO_FAILURE:
      return {
        error: action.message,
        isfetching: false,
        isSuccess: false,
        success: ''
      };
    default:
      return state;
  }
};
